import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import JfrogXrayConfigListing from './JfrogXrayConfigListing';
import JfrogXrayCredentialForm from './JfrogXrayCredentialForm';

export default function JfrogXrayPullAndPushView(props){
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={JfrogXrayCredentialForm}
            PullConfigListingView={JfrogXrayConfigListing}
        />
    )
}